import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { connectable, Observable, ReplaySubject } from 'rxjs';
import {
  distinctUntilChanged,
  distinctUntilKeyChanged,
  map,
  switchMap,
} from 'rxjs/operators';
import { filterForInstanceOf } from '../../../utils/rxjs/filterForInstanceOf';

@Injectable({ providedIn: 'root' })
export class RouterAuxService {
  activatedRoute$: Observable<ActivatedRoute>;
  routeData$: Observable<any>;

  navigationEnd$ = this.router.events.pipe(filterForInstanceOf(NavigationEnd));

  constructor(private router: Router, activatedRoute: ActivatedRoute) {
    const routeData$ = router.events.pipe(
      switchMap(() => {
        const leafRoute = this.leafRoute(activatedRoute);
        return leafRoute.data;
      }),
      distinctUntilChanged()
    );

    const connectedRouteData = connectable(routeData$, {
      resetOnDisconnect: false,
      connector: () => new ReplaySubject(1),
    });

    connectedRouteData.connect();

    this.routeData$ = connectedRouteData;

    const activatedRoute$ = this.navigationEnd$.pipe(
      distinctUntilKeyChanged('urlAfterRedirects'),
      map(() => this.leafRoute(activatedRoute))
    );

    const connectedActivatedRoute = connectable(activatedRoute$, {
      resetOnDisconnect: false,
      connector: () => new ReplaySubject(1),
    });

    connectedActivatedRoute.connect();

    this.activatedRoute$ = connectedActivatedRoute;
  }

  leafRoute(rootRoute: ActivatedRoute): ActivatedRoute {
    while (rootRoute.firstChild) {
      rootRoute = rootRoute.firstChild;
    }
    return rootRoute;
  }
}
